import React, {useState, useEffect} from "react";
import {WhyUs} from "../Components/whyUs.jsx";
import {hopnLanguageArray} from "@/utils/functions.js";
import {HopnPerks} from "../Components/hopnPerks.jsx";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {planeTakeOffSlim, arrRight, arrowRightSlim} from "@img/index.js";

export function FlightAirportTo({setStep, closeModal}) {
    const [whyUsPopup, setWhyUsPopup] = useState(false);
    const [airportName, setAirportName] = useState(null);

    useEffect(() => {
        const stored = storage.get(STORAGE_KEYS.AIRPORT_DETAILS);
        if (stored) setAirportName(stored);
    }, []);

    return (
        <>
            {whyUsPopup && (
                <div className="whyUs" hopn-data-category="second_banner">
                    <WhyUs setWhyUsPopup={setWhyUsPopup}/>
                </div>
            )}
            <ModalHeader title="Flight Details" extraClasses="" totalSteps={1} cancelButton={false} cancelButtonType="text" backStep="flightAirportDetails" showBackButton={true} enableEditModeOnBackButton={false} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-date-info-layout plane-details-tab modalPages-spacing pb-8">
                <div className="inner-tab">
                    <h2>Your flight to {airportName ? airportName.code : '...'}</h2>
                    <div className="hopn-departure-airports">
                        <h4>Departure airport</h4>
                        <button onClick={() => setStep('flightAirportLists')}>
                            <h6><img decoding="async" src={planeTakeOffSlim} alt="Departure Plane"/> Where are you flying from?</h6>
                            <div className="btn"><img decoding="async" src={arrRight} alt="Right arrow"/></div>
                        </button>
                    </div>
                </div>
                <div className="inner-tab hopn-banner-right">
                    <div className="hopn-banner-right-inner">
                        <HopnPerks key="1" sliderOnly modalStyle="popup"/>
                        <button className="clearStyle" onClick={() => setWhyUsPopup(true)}>
                            {hopnLanguageArray("second_banner", "more_airport_pickup_perks", "More airport pickup Perks")}
                            <span><img src={arrowRightSlim} alt="Arrow Right"/></span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}
export default FlightAirportTo;
